  <app-request class="request-item"
                 *ngFor="let request of requests"
                 [request]="request"
                 [isSelectedRequest]="request.id.toString() === getTrackedRequestId()"
                 (selectedRequestChange)="onSelectedRequestChange($event)">
  </app-request>

